module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-top.fbc351ac.svg";